import { FeatureOption as UserFeaturesItemEnum } from "../../data/models/schemas";
import type { FeatureOption as UserFeaturesItemType } from "../../data/models/schemas";

export const UserFeaturesItem = UserFeaturesItemEnum;
export type UserFeaturesItem = UserFeaturesItemType;

export type IUserState = {
    id?: number;
    organization_id?: number;
    email?: string;
    company?: string;
    environment?: string;
    userName?: string;
    firstName?: string;
    lastName?: string;
    csrf_token?: string;
    socket_token?: string;
    units?: number;
    license_id?: number;
    licenseDisplayName?: string;
    lastLoggedIn?: number;
    licenseEnd?: number;
    hasLicense?: boolean;
    hasUserAdmin?: boolean;
    hasBilling?: boolean;
    hasMyAccount?: boolean;
    hasApiKeys?: boolean;
    license?: string;
    features?: UserFeaturesItem[];
    seats?: number;
    role?: string;
    hasPendingAwsActivation?: boolean;
    isLicensedForEstimation?: boolean;
};

export const userHasFeature = (
    user: IUserState,
    feature: UserFeaturesItem
): boolean =>
    user.features?.some(
        (f) => f === UserFeaturesItem.ALL_FEATURES || f === feature
    ) ?? false;

const DATA_MANAGEMENT_FEATURE = UserFeaturesItem.ViridisChemDataManagement;

export const userCanManageData = (user: IUserState): boolean =>
    userHasFeature(user, DATA_MANAGEMENT_FEATURE);
